module.exports = __webpack_public_path__ + "static/media/webfont.3b23abde.woff2";